<template>
    <div class="login">
        <b-container>
            <b-row>
                <b-col>
                    <img src="@/assets/logo_white.png" class="logo mt-4 mb-2 mr-4"/>

                    <div class="box">
                        <h2 class="mb-4">Organization Login</h2>
                        <p class="mb-5"><strong>Note: </strong>Login for conference organizers and presenters only.</p>

                        <b-form @submit.prevent="formSubmit">
                            <b-row>
                                <b-col cols="4">
                                    <b-form-group label="E-Mail Address:" label-for="input-1">
                                        <b-form-input id="input-1" v-model="email" type="email" required></b-form-input>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="4">
                                    <b-form-group label="Password:" label-for="input-2">
                                        <b-form-input id="input-2" v-model="password" type="password" required></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <div>
                                <b-button type="submit" variant="success" class="mr-2" :disabled="processing || !email || !password">Login<i class="fas fa-sign-in"></i></b-button>
                                <b-button variant="light" to="/">Cancel</b-button>
                            </div>
                        </b-form>
                    </div>

                </b-col>
            </b-row>
            <copyright/>
        </b-container>
    </div>
</template>

<script>
    import Copyright from "../../components/Copyright";
    import {mapGetters, mapActions} from 'vuex';

    export default {
        name: "login",
        components: {Copyright},
        data() {
            return {
                email: '',
                password: ''
            }
        },
        computed: {
            ...mapGetters(['currentUser', 'processing', 'loginError'])
        },
        methods: {
            ...mapActions(['login']),
            formSubmit() {
                this.login({email: this.email, password: this.password}).catch(error => {
                    // Error handled by loginError();
                });
            }
        },
        watch: {
            currentUser(val) {
                if (val && val.id) {
                    // console.log('Login: watch/currentUser:', val);
                    // console.log(val.role);
                    switch (val.role) {
                        case 'admin':
                            this.$router.push('/admin/dashboard');
                            break;
                        case 'user':
                            this.$router.push('/org/dashboard');
                            break;
                        default:
                            console.warn('Default login redirect occurred.');
                            this.$router.push('/user/login');
                    }
                }
            },
            loginError(err) {
                if (err && err.message) {
                    this.$notify('error', 'Login Error', err.message, {duration: 5000, permanent: false});
                } else if (err && err.error && err.error.text) {
                    this.$notify('error', 'Login Error', err.error.text, {duration: 5000, permanent: false});
                } else if (err) {
                    this.$notify('error', 'Login Error', 'An unknown error occurred. Please try again later.', {duration: 5000, permanent: false});
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    .login {
        text-align: center;
        background: $green; /* fallback */
        background: linear-gradient( to bottom, $green, darken($green, 15));
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 100%;
        padding: 5rem;

        .box {
            padding: 2rem;
            background: white;
            margin: 5rem;
            border-radius: 0.5rem;
            text-align: left;
            box-shadow: 0 0 39px 10px rgba(0,0,0,0.5);

            background-image:url('~@/assets/header-bg-image.png');
            background-repeat:no-repeat;
            background-position: right bottom;
            background-size: 350px;

            .btn {
                i {
                    margin-left: 0.7em;
                }
            }
        }
    }

</style>